module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-news-events"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props && !_vm.loading) ? _c('div', [_c('div', {
    staticClass: "pages-news-events__body"
  }, [_vm._m(0), _c('div', {
    staticClass: "pages-news-events__container"
  }, [_vm._m(1), _c('Gallery', {
    attrs: {
      "content": _vm.content.acf.contests
    }
  })], 1)])]) : _vm._e(), _c('FooterMain')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-news-events__container"
  }, [_c('div', {
    staticClass: "pages-news-events__title"
  }, [_vm._v("Upcoming and Current News and Events:        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-news-events__fb-container"
  }, [_c('div', {
    staticClass: "pages-news-events__fb"
  }, [_c('iframe', {
    staticStyle: {
      "border": "none",
      "overflow": "hidden"
    },
    attrs: {
      "src": "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FOPsmiles%2F&tabs=timeline,events&width=500&height=1000&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId",
      "width": "100%",
      "height": "700px",
      "scrolling": "no",
      "frameborder": "0",
      "allowTransparency": "true"
    }
  })]), _c('div', {
    staticClass: "pages-news-events__fb--mobile"
  }, [_c('iframe', {
    staticStyle: {
      "border": "none",
      "overflow": "hidden"
    },
    attrs: {
      "src": "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FOPsmiles%2F&tabs=timeline,events&width=300&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId",
      "width": "100%",
      "height": "500px",
      "scrolling": "no",
      "frameborder": "0",
      "allowTransparency": "true"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-323c59ac","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/news-events/news-events.pug
// module id = 624
// module chunks = 1